import React from 'react'

export default function Airplane({ className }) {
  return (
    <svg viewBox="0 0 19 17" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M0 7V1C0 .409-.129-.325 3 1s15 7 15 7 .834.511 0 1-16 7-16 7l-2 1v-7s15-1.157 15-2C13.834 7.667 0 7 0 7z"
      />
    </svg>
  )
}
